import { DateTime } from "luxon";

/**
 * The days the booking calendar asks availability for.
 *
 * The month grid also shows the neighbouring months' days that complete its first and
 * last week (up to 6 each side, depending on the locale's first weekday) — viewing
 * September also shows 1–4 October. Fetched for the month alone, those days had no
 * data and were greyed out although they had free slots. So the range runs a week
 * beyond the month on both sides, never before today.
 */
export const GRID_BUFFER_DAYS = 7;

export function visibleDateRange(monthStart: DateTime, todayISO: string, zone: string,
                                 bufferDays: number = GRID_BUFFER_DAYS): string[] {
  const today = DateTime.fromISO(todayISO, { zone }).startOf("day");
  const first = monthStart.startOf("month").minus({ days: bufferDays });
  const last = monthStart.endOf("month").plus({ days: bufferDays }).startOf("day");
  let d = first < today ? today : first;
  const out: string[] = [];
  while (d <= last) {
    out.push(d.toISODate() as string);
    d = d.plus({ days: 1 });
  }
  return out;
}
